export const getFlagEmojiFromCountryCode = (
  countryCode: string
): string | undefined => {
  const match = /^[a-zA-Z]{2}-[a-zA-Z]{2}$/.exec(countryCode)

  if (!match) {
    return undefined
  }

  const country = countryCode.split('-')[1]?.toUpperCase()

  if (!country) {
    return undefined
  }

  const codePoints = country
    .split('')
    .map((char) => 127397 + char.charCodeAt(0))

  return String.fromCodePoint(...codePoints)
}
